
export const styles = {
    loadingContainer: {
        position: 'fixed',   
        top: '50%',          
        left: '50%',         
        transform: 'translate(-50%, -50%)', 
      }
}